// Раздел «Настроек», который раскрывается по нажатию на заголовок (уведомления, баннеры, iikoCloud).
// Содержимое монтируется при раскрытии — и данные раздела грузятся только тогда.
// Раскрыт ли раздел — запоминается в браузере (удобство, не обязательно: без хранилища — свёрнут).
import React, { useId, useState } from 'react';
import { Box, ButtonBase, Collapse, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ACCORDION_BUTTON_SX, MUTED_TEXT_COLOR } from '../../styles/tokens';

const storageKey = (id) => `settings.section.${id}`;

function readOpen(id) {
  try {
    return localStorage.getItem(storageKey(id)) === '1';
  } catch {
    return false;
  }
}

function writeOpen(id, open) {
  try {
    localStorage.setItem(storageKey(id), open ? '1' : '0');
  } catch {
    // хранилище недоступно (приватный режим) — просто не запоминаем
  }
}

export default function CollapsibleSection({ id, title, summary, sx, children }) {
  const [open, setOpen] = useState(() => readOpen(id));
  const contentId = useId();

  const toggle = () => {
    setOpen((prev) => {
      writeOpen(id, !prev);
      return !prev;
    });
  };

  return (
    <Box sx={sx}>
      <ButtonBase
        onClick={toggle}
        aria-expanded={open}
        aria-controls={contentId}
        sx={{ ...ACCORDION_BUTTON_SX, mx: -1, width: 'calc(100% + 16px)' }}
      >
        <Typography component="h2" sx={{ fontWeight: 600, fontSize: '1rem', color: '#fff' }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          {summary && !open && (
            <Typography noWrap sx={{ fontSize: '13px', color: MUTED_TEXT_COLOR }}>
              {summary}
            </Typography>
          )}
          <ExpandMoreIcon
            aria-hidden="true"
            sx={{
              color: MUTED_TEXT_COLOR,
              transition: 'transform 0.2s ease',
              transform: open ? 'rotate(180deg)' : 'none',
              '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
            }}
          />
        </Box>
      </ButtonBase>
      <Collapse in={open} timeout="auto" unmountOnExit id={contentId}>
        <Box sx={{ pt: 1 }}>{children}</Box>
      </Collapse>
    </Box>
  );
}
